import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Easeedesk > AI Analizer Actions > Quick Diagnostic Actions / Top Users
 * (v4/api, `App\Settings\Diagnostic\QuickDiagnosticActions`). Forma paginii
 * e inghetata in `settings/diagnostic/__fixtures__/quickDiagnosticActions.json`.
 */
const BASE = '/settings/diagnostic'

export interface DiagnosticScope {
  id: number
  scope: string
  scope_type: string
  scope_key: string
}

export interface QuickDiagnosticActionsPage {
  scopes: DiagnosticScope[]
  commands: { id: number; display_name: string; type_name: string }[]
}

export interface QuickDiagnosticAction {
  id: number
  company_id: number
  scope_id: number
  scope_condition: string
  condition_value: string
  command_id: number
}

export interface TableRequest {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderName: string
  orderDir: 'asc' | 'desc'
  search: string
}

export interface TablePage<T> {
  draw: number
  recordsTotal: number
  recordsFiltered: number
  data: T[]
}

function params(r: TableRequest): string {
  const p = new URLSearchParams()
  p.set('draw', String(r.draw))
  p.set('start', String(r.start))
  p.set('length', String(r.length))
  p.set('order[0][column]', String(r.orderColumn))
  p.set('order[0][dir]', r.orderDir)
  p.set(`columns[${r.orderColumn}][name]`, r.orderName)
  p.set('search[value]', r.search)
  return p.toString()
}

export function quickDiagnosticActionsQuery() {
  return queryOptions({
    queryKey: ['settings', 'diagnostic', 'actions'],
    queryFn: () => apiGet<QuickDiagnosticActionsPage>(`${BASE}/actions`),
  })
}

export function quickDiagnosticActionsTableQuery(r: TableRequest) {
  return queryOptions({
    queryKey: ['settings', 'diagnostic', 'actions', 'table', r],
    queryFn: () => apiGet<TablePage<Record<string, unknown>>>(`${BASE}/actions/table?${params(r)}`),
  })
}

export function quickDiagnosticActionQuery(id: number) {
  return queryOptions({
    queryKey: ['settings', 'diagnostic', 'actions', 'one', id],
    queryFn: () => apiGet<QuickDiagnosticAction>(`${BASE}/actions/${id}`),
    enabled: id > 0,
  })
}

export interface ActionFields {
  scope_id: string
  scope_condition: string
  condition_value: string
  command_id: string
}

export function createQuickDiagnosticAction(fields: ActionFields) {
  return apiPost<{ status: string; id: number }>(`${BASE}/actions`, { ...fields })
}

export function updateQuickDiagnosticAction(id: number, fields: ActionFields) {
  return apiPost<{ status: string; id: number }>(`${BASE}/actions/${id}`, { ...fields })
}

export function removeQuickDiagnosticAction(id: number) {
  return apiPost<{ status: string; id: number }>(`${BASE}/actions/${id}/remove`, {})
}

export function aiTopUsersTableQuery(r: TableRequest) {
  return queryOptions({
    queryKey: ['settings', 'diagnostic', 'top_users', r],
    queryFn: () => apiGet<TablePage<Record<string, unknown>>>(`${BASE}/top_users/table?${params(r)}`),
  })
}
